import { useState, useEffect, useCallback } from "react";
import { useUpdateDarkModeMutation } from "../libs/user/api";

export const useDarkMode = () => {
  const [isDark, setIsDark] = useState(() => {
    const stored = localStorage.getItem("color-theme");
    if (stored) return stored === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  const [updateDarkMode] = useUpdateDarkModeMutation();

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("color-theme", isDark ? "dark" : "light");
  }, [isDark]);

  const toggle = useCallback(() => {
    setIsDark((prev) => {
      const next = !prev;
      updateDarkMode({ darkMode: next });
      return next;
    });
  }, [updateDarkMode]);

  return { isDark, toggle };
};
